import React from 'react';
import PropTypes from 'prop-types';
import refPropType from '../refPropTypes';

const NumberInput = ({ step, inputRef, ...otherProps }) => (
  <input type="text" pattern="\d*" step={step} ref={inputRef} {...otherProps} />
);

NumberInput.displayName = 'NumberInput';

NumberInput.propTypes = {
  step: PropTypes.number,
  inputRef: refPropType,
};

NumberInput.defaultProps = {
  step: 1,
  inputRef: null,
};

export default NumberInput;
